import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSelectedAddons, removeAddon } from "../modules/quotes.slice";
import { useTypedSelector } from "./useTypedSelector";
import useUrlQuery from "./useUrlQuery";

const useFilters = () => {
  const { getUrlQuery } = useUrlQuery();
  const addOnsParam = getUrlQuery("addons") || "0";
  const dispatch = useDispatch();
  const { selectedAddons } = useTypedSelector((state) => state.quote);

  // useEffect(() => {
  //   const value = Number(addOnsParam);

  //   const handleToggle = (bitMask: number, slug: string) => {
  //     if (value & bitMask) {
  //       dispatch(setSelectedAddons(slug));
  //     } else {
  //       dispatch(removeAddon(slug));
  //     }
  //   };

  //   handleToggle(4, "PA_COVER");
  //   handleToggle(8, "ELECTRICAL_ACCESSORIES");
  //   handleToggle(16, "NON_ELECTRICAL_ACCESSORIES");
  //   handleToggle(32, "NILL_DEPT");
  // }, [addOnsParam, dispatch]);

  return { selectedAddonsParam: Number(addOnsParam) };
};

export default useFilters;
